<template>
  <div id="app">
    <mobile v-if="width <= breakpoint"></mobile>
    <div class="view-wrapper" v-else>
      <loading v-if="loading"/>
      <router-view v-else/>
      <lines/>
      <app-title/>
      <social/>
      <lab-switcher/>
    </div>
  </div>
</template>

<script>

import LabSwitcher from '@/components/LabSwitcher'
import appTitle from '@/components/Title'
import Social from '@/components/Social'
import Mobile from '@/components/Mobile'
import Lines from '@/components/Lines'
import Loading from '@/components/Loading'

import projects from '@/json/projects'

export default {
  name: 'App',
  components: {
    appTitle,
    Social,
    LabSwitcher,
    Mobile,
    Lines,
    Loading,
  },
  data() {
    return {
      width: window.innerWidth,
      breakpoint: 800,
      loading: true,
      urls: []
    }
  },
  created() {
    window.addEventListener('resize', () => {
      this.width = window.innerWidth
    })
  },
  mounted() {
     projects.forEach(project => {
      this.urls.push(require(`@/assets/images/projects/${project.slug}.jpg`))
      this.urls.push(require(`@/assets/images/projects/bg/${project.slug}.jpg`))
    })

    const promises = this.getPromises(this.urls)
    Promise.all(promises)
      .then(res => {
        this.loading = false;
      })
  },
  methods: {
    getPromises(array) {
      const promises = []
      array.forEach(url => {
        let promise = new Promise((resolve, reject) => {
            let img = new Image()
            img.onload = () => {
              resolve(url)
            }
            img.onerror = () => {
              reject(url)
            }
            img.src = url
          })
        promises.push(promise)
      });
      
      return promises
    },
  }
}

</script>

<style lang="scss">
:root{
  --white: #FCFCFC;
  --black: #000000;
  --grey:  #8b8b8b;
  --light-grey: #ECECEC;
  --primary: #FA8A66;
  --primary--light: rgb(255, 223, 212);
  --DIN: 'DINCond', Helvetica, sans-serif;
  --conduitITC: 'Conduit ITC', Helvetica, sans-serif;
  --editor: 'Editor', Helvetica, sans-serif;
  --body-padding: 5.5vw;
  --easing: cubic-bezier(0.785, 0.135, 0.15, 0.86);
}

html,body{
  width: 100%;
  height: 100%;
  overflow: hidden;
  font-size: 62.5%;
  background: var(--white);
}

#app{
  width: 100%;
  height: 100%;
  .view-wrapper {
    width: 100%;
    height: 100%;
    perspective: 1000px;
    transform-style: preserve-3d;
  }
}

*,*::before,*::after{
  box-sizing: border-box;
}

h1,h2,h3,h4,h5,h6,p,ul{
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue